/** @jsx jsx */
import { Icon, PopOut } from "@cd2/components/build/es6"
import { useTheme } from "@cd2/theme/build/es6"
import { css, jsx } from "@emotion/core"

export function HelpPopOut({ icon, children }: { icon?: string; children: React.ReactNode }) {
  const theme = useTheme()
  return (
    <PopOut
      placement="top"
      openOn="hover"
      target={() => (
        <Icon
          css={css`
            cursor: help !important;
          `}
          icon={icon ?? "question-circle"}
        />
      )}
      render={() => (
        <div
          css={css`
            padding: 8px;
            background: white;
            box-shadow: ${theme.boxShadow.lg};
            max-width: 200px;
          `}
        >
          {children}
        </div>
      )}
    />
  )
}
